<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Project Management</h1>
      <p>
        In order to manage projects in the USE web application, the user authentication process must first succeed. To
        do so, the user can either click on the login button in the top-right corner of the application's home page,
        or click on the <i class="fas fa-list-ul" /> Hamburger Menu on the top-left side, and then click "Projects".
        In either case, the user must provide a valid e-mail and password combination.
      </p>

      <div class="image-container">
        <img src="@/images/manual/login-page.png" alt="Login Process" />
        <div class="img-caption">Figure 1. Credentials In Login Page</div>
      </div>

      <p>
        After a successful log in the user will be redirected to their personal projects page (see image below). The Projects
        Page contains a list of projects sorted by the date they were last updated. If a user manages more than five projects,
        the projects will be displayed in pages of five. In such cases - i.e. when the user owns more than five (5) projects -
        the user can navigate through the list's pages using the selection in the bottom part of the table. It is also possible
        to configure the list to display more than five projects (5) at once.
      </p>

      <div class="image-container">
        <img src="@/images/manual/projects-page-full.png" alt="Full Projects Page" />
        <div class="img-caption">Figure 2. The Projects Page with more than five projects. The controls are on the bottom-right
          side of the table.
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
